import api from './api';

class BranchService {
  async getAllBranches(params = {}) {
    const response = await api.get('/branches', { params });
    return response.data;
  }

  async getBranchById(id) {
    const response = await api.get(`/branches/${id}`);
    return response.data;
  }

  async createBranch(data) {
    const response = await api.post('/branches', data);
    return response.data;
  }

  async updateBranch(id, data) {
    const response = await api.put(`/branches/${id}`, data);
    return response.data;
  }

  async deleteBranch(id) {
    const response = await api.delete(`/branches/${id}`);
    return response.data;
  }

  async toggleBranchStatus(id, is_active) {
    const response = await api.patch(`/branches/${id}/status`, { is_active });
    return response.data;
  }
}

export default new BranchService();
